(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/constants.js');
"use strict";


const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS'
};
const HTTP_METHODS = Object.values(HTTP_METHOD);
const FEATURE_TOGGLE = {
  MARKETPLACE_BOMBEN_DRAWS_CLOUD_API: 'ft-marketplace-bomben-draws-cloud-api',
  MARKETPLACE_BOMBEN_PIX_CLOUD_API: 'ft-marketplace-bomben-pix-cloud-api',
  MARKETPLACE_CHALLENGE_DRAWS_CLOUD_API: 'ft-marketplace-challenge-draws-cloud-api',
  MARKETPLACE_CHALLENGE_PIX_CLOUD_API: 'ft-marketplace-challenge-pix-cloud-api',
  MARKETPLACE_EUROPATIPSET_DRAWS_CLOUD_API: 'ft-marketplace-europatipset-draws-cloud-api',
  MARKETPLACE_EUROPATIPSET_PIX_CLOUD_API: 'ft-marketplace-europatipset-pix-cloud-api',
  MARKETPLACE_MALTIPSET_DRAWS_CLOUD_API: 'ft-marketplace-maltipset-draws-cloud-api',
  MARKETPLACE_MALTIPSET_PIX_CLOUD_API: 'ft-marketplace-maltipset-pix-cloud-api',
  MARKETPLACE_MATCHEN_DRAWS_CLOUD_API: 'ft-marketplace-matchen-draws-cloud-api',
  MARKETPLACE_MATCHEN_PIX_CLOUD_API: 'ft-marketplace-matchen-pix-cloud-api',
  MARKETPLACE_POWERPLAY_DRAWS_CLOUD_API: 'ft-marketplace-powerplay-draws-cloud-api',
  MARKETPLACE_POWERPLAY_PIX_CLOUD_API: 'ft-marketplace-powerplay-pix-cloud-api',
  MARKETPLACE_STRYKTIPSET_DRAWS_CLOUD_API: 'ft-marketplace-stryktipset-draws-cloud-api',
  MARKETPLACE_STRYKTIPSET_PIX_CLOUD_API: 'ft-marketplace-stryktipset-pix-cloud-api',
  MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API: 'ft-marketplace-topptipset-draws-cloud-api',
  MARKETPLACE_TOPPTIPSET_PIX_CLOUD_API: 'ft-marketplace-topptipset-pix-cloud-api',
  MARKETPLACE_PAM_CORE_CLOUD_API: 'ft-marketplace-pam-core-cloud-api',
  MARKETPLACE_MEDIA_SOC_CLOUD_API: 'ft-marketplace-media-soc-cloud-api'
};
const constantsExport = {
  HTTP_METHOD,
  HTTP_METHODS,
  FEATURE_TOGGLE
};
if (svs.isServer) {
  module.exports = constantsExport;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.constants', constantsExport);
}

 })(window);